module.exports = __webpack_public_path__ + "img/checkmark_icon.3afacd3e.svg";